import LanguageSwitcher from 'src/components/language-switcher/language-switcher.component'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { useTranslation } from 'react-i18next'
import {
  EPermissionGrantActions,
  EPermissionGrantSubjects,
} from 'src/pages/configuration/permissions/_components/permissions.type'
import PageTitle from 'src/components/page-title/page-title.component'
import { CurecallButton } from '@honestica/curecall-ui'
import { AuthForm } from 'src/pages/medical/account/_components/auth-form.component'
import TwoFactorSettings from 'src/pages/medical/account/_components/two-factor-settings.component'
import { useSession } from 'src/providers/auth.provider'
import { AdminOnlyBadge } from 'src/components/admin-only-badge.component'
import { useLocalizedNavigate } from 'src/hooks/use-localized-navigate'
import { useParams } from 'react-router-dom'

export default function AccountPage() {
  const { hasPermission } = useCurrentProject()
  const { currentUser } = useSession()
  const navigate = useLocalizedNavigate()
  const { t } = useTranslation()
  const { projectId } = useParams<{ projectId: string }>()

  return (
    <div>
      <div className="c-flex c-justify-between c-pb-4">
        <PageTitle>{t('pages.auth.title.account')}</PageTitle>

        {hasPermission(EPermissionGrantSubjects.USER_MANAGEMENT, EPermissionGrantActions.GET) && (
          <CurecallButton onClick={() => navigate(`/${projectId}/medical/users`)}>
            {t('pages.auth.account.manage-users')}
          </CurecallButton>
        )}
      </div>
      <div className="c-border-b c-border-b-grey-200 c-mb-5" />
      <LanguageSwitcher />
      <div className="c-flex c-flex-col xl:c-flex-row c-gap-6 c-mb-4">
        <div className="c-w-full xl:c-w-1/2">
          <h4>{t('pages.auth.account.update-password-with-form')}</h4>
          <section id="auth-form" className="c-mt-10 c-w-full">
            <AuthForm />
          </section>
        </div>
        {currentUser?.isAdminOrSales && (
          <div className="c-w-full xl:c-w-1/2">
            <h4 className="c-flex c-items-center c-gap-1">
              {t('pages.auth.account.two-factor.section-title')}
              <AdminOnlyBadge />
            </h4>
            <section className="c-mt-4 c-w-full">
              <TwoFactorSettings />
            </section>
          </div>
        )}
      </div>
    </div>
  )
}
